<template>
  <vue-instagram token="273c3694cc534943b57edfc2890d588a" :count="9" :tags="['#olpejeta', '#olpejetaconservancy']" mediaType="image">
    <template slot="feeds" slot-scope="props">
      <li class="fancy-list"> {{ props.feed.link }} </li>
    </template>
    <template slot="error" slot-scope="props">
      <div class="fancy-alert"> {{ props.error.error_message }} </div>
    </template>
  </vue-instagram>
</template>

<script>
import VueInstagram from 'vue-instagram'
export default {
  name: 'InstaFeed',
  components: {
    VueInstagram
  }
}
</script>
